module.exports = __webpack_public_path__ + "assets/3d092d3a9b7ceffc1b69a5fb894d300d.mp4";